// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__Asp9k","inner":"Footer_inner__JuX7R","top":"Footer_top__xkkNH","description":"Footer_description__xKgXv","copyright":"Footer_copyright__mX+Pr"};